'use strict';

var _ = require('lodash');
var ComboboxDirective = function ComboboxDirective($timeout, eventsService, itemsListService, userSecureService, $document) {
  var DEFAULT_PLACEHOLDER = 'Select...';
  var DEFAULT_INPUT_TYPE = 'string';
  var DEFAULT_ID_PROPERTY = 'id';
  var DEFAULT_LABEL_PROPERTY = 'label';
  var DEFAULT_LABEL_PREFIX_PROPERTY = 'labelPrefix';

  /**
   *
   * @param value
   * @returns {boolean}
   */
  function stringToBoolean(value) {
    return value === 'true';
  }

  /**
   *
   * @param scope
   */
  function setDefaultValues(scope) {
    scope.editable = stringToBoolean(scope.editable);
    scope.validate = stringToBoolean(scope.validate);
    scope.inputType = scope.inputType || DEFAULT_INPUT_TYPE;
    scope.typeAhead = stringToBoolean(scope.typeAhead);
    scope.showTooltip = stringToBoolean(scope.showTooltip);
    scope.placeholder = _.isUndefined(scope.placeholder) ? DEFAULT_PLACEHOLDER : scope.placeholder;
    scope.idPropertyName = scope.idPropertyName || DEFAULT_ID_PROPERTY;
    scope.labelPropertyName = scope.labelPropertyName || DEFAULT_LABEL_PROPERTY;
    scope.labelPrefixPropertyName = scope.labelPrefixPropertyName || DEFAULT_LABEL_PREFIX_PROPERTY;
    scope.resetSelectionEnabled = stringToBoolean(scope.resetSelectionEnabled);
    scope.inputEnabled = scope.editable || scope.typeAhead;
    scope.isInvalidInput = false;
    scope.returnId = stringToBoolean(scope.returnId);
    scope.isDisabled = scope.isDisabled || false;
    scope.fixedPosition = stringToBoolean(scope.fixedPosition);
    scope.customizableItems = scope.customizableItems || [];
    scope.scrollPosition = 'inview#top';
    scope.defaultLabel = scope.defaultLabel || '';
    itemsListService.setList(scope);
  }
  return {
    restrict: 'E',
    replace: true,
    require: 'ngModel',
    template: require('../templates/combobox.html'),
    scope: {
      name: '@',
      // [true,false*]
      isDisabled: '=?',
      itemList: '=',
      customizableItems: '=?',
      // [true,false*]
      editable: '@',
      // ['true','false'*]
      validate: '@',
      // [string*,number]
      inputType: '@',
      // [true,false*]
      typeAhead: '@',
      // [true,false*]
      showTooltip: '@',
      // [default='Select...']
      placeholder: '@',
      // [default='id']
      idPropertyName: '@',
      // [default='label']
      labelPropertyName: '@',
      // [default='labelPrefix']
      labelPrefixPropertyName: '@',
      // [default='false']
      resetSelectionEnabled: '@',
      // [default='false']
      returnId: '@',
      //[true,false]
      fixedPosition: '@',
      //[default='']
      defaultLabel: '@',
      //component allowed
      allowInComponent: '@?',
      //permission level
      withPermission: '@?'
    },
    link: function link(scope, elem, attr, ngModelCtrl) {
      var mouseDownOnOptionsHappened;
      var ul = elem.find('ul');
      var input = elem.find('input');
      var dropdown = elem.find('.dropdown');
      var dropdownToggle = elem.find('.dropdown-toggle');
      var newItem;
      setDefaultValues(scope);
      function checkPermission() {
        if (typeof scope.allowInComponent !== 'undefined') {
          scope.isAuthorized = userSecureService.hasAuthorization(scope.allowInComponent, scope.withPermission || 'write');
        }
      }

      /**
       *
       */
      function render() {
        itemsListService.filterList(scope);
        var placeholder = scope.placeholder;
        var defaultLabel = scope.defaultLabel;
        var viewValue = ngModelCtrl.$viewValue;
        scope.label = viewValue && scope.itemToLabel(viewValue) || defaultLabel || placeholder;
        scope.labelPrefix = viewValue && scope.itemToLabelPrefix(viewValue) || '';
        if (scope.label === placeholder && scope.editable && input.val() !== '') {
          scope.label = input.val();
        }
        elem.toggleClass('unselected-value', scope.label === placeholder || scope.label === defaultLabel);
        if (scope.inputEnabled) {
          input.val(scope.label);
        }
        if (scope.showTooltip) {
          dropdown.attr('data-original-title', scope.label);
        }
        checkPermission();
      }

      /**
       *
       */
      function setDropdownStyles() {
        var boundingClientRect;
        if (scope.fixedPosition) {
          boundingClientRect = dropdown[0].getBoundingClientRect();
          scope.dropdownStyle = {
            position: 'fixed',
            minWidth: '160px',
            width: boundingClientRect.width,
            top: boundingClientRect.top + boundingClientRect.height,
            left: boundingClientRect.left
          };
          $document.one('scroll', function () {
            if (dropdown.hasClass('open')) {
              hideDropdown();
            }
          });
        } else {
          scope.dropdownStyle = {
            position: 'absolute'
          };
        }
      }

      /**
       *
       */
      function showDropdown() {
        dropdownToggle.dropdown('toggle');
        setDropdownStyles();
        scope.$apply();
      }
      function getVisibleLabel(item) {
        return _.isFunction(item) ? item() : item;
      }

      /**
       *
       */
      function hideDropdown() {
        dropdownToggle.dropdown('toggle');
        dropdown.unbind('show.bs.dropdown', setDropdownStyles);
        dropdown.tooltip('hide');
      }

      /**
       *
       * @param item
       * @returns {*}
       */
      function getValue(item) {
        if (scope.returnId && item && item[scope.idPropertyName]) {
          return item[scope.idPropertyName];
        }
        return item;
      }

      /**
       *
       * @param item
       * @returns {number}
       */
      function getIndex(item) {
        return scope.filteredItemList.indexOf(item);
      }
      scope.getIndex = getIndex;

      /**
       *
       * @param item
       */
      scope.scrollTo = function (item) {
        var index = getIndex(item);
        var position = scope.scrollPosition || 'inview#top';
        scope.$broadcast('vsRepeatTrigger', {
          scrollIndex: index,
          scrollIndexPosition: position
        });
      };

      /**
       * The item that will be provided from ngModelCtrl.$viewValue may not be the one that's in itemList
       * that's why the label needs to be searched by id (the property name is kept in idPropertyName)
       * if it not defined read label by labelPropertyName (input entered value)
       *
       * @param item
       * @returns {*}
       */
      scope.itemToLabel = function (item) {
        if (_.isString(item)) {
          return item;
        } else {
          var id = item[scope.idPropertyName];
          var value = scope.itemMap && scope.itemMap[id];
          return value || getVisibleLabel(item[scope.labelPropertyName]);
        }
      };

      /**
       *
       * @param item
       * @returns {*}
       */
      scope.itemToLabelPrefix = function (item) {
        return item[scope.labelPrefixPropertyName];
      };

      /**
       *
       * @param item
       * @returns {boolean}
       */
      scope.hasLabelPrefix = function (item) {
        return _.has(item, scope.labelPrefixPropertyName) && !_.isEmpty(item[scope.labelPrefixPropertyName]);
      };

      /**
       *
       * @param item
       */
      scope.selectItem = function (item) {
        var value = item && item.reset ? undefined : getValue(item);
        if (_.has(item, 'action')) {
          item.action(scope);
        } else {
          ngModelCtrl.$setViewValue(value);
          ngModelCtrl.$setValidity('required', true);
          render();
          scope.activeIndex = getIndex(item);
        }
        hideDropdown();
        elem.focus();
      };

      /**
       *
       * @param item
       */
      scope.addItem = function (item) {
        newItem = item;
      };
      scope.$watch('isDisabled', function () {
        if (!_.isUndefined(scope.isAuthorized) && !scope.isAuthorized) {
          dropdownToggle.attr('disabled', 'disabled');
          dropdownToggle.addClass('disabled');
          if (scope.inputEnabled) {
            input.attr('disabled', 'disabled');
          }
        } else if (scope.isDisabled === true) {
          dropdownToggle.attr('disabled', 'disabled');
          dropdownToggle.addClass('disabled');
          if (scope.inputEnabled) {
            input.attr('disabled', 'disabled');
          }
        } else {
          dropdownToggle.removeAttr('disabled');
          dropdownToggle.removeClass('disabled');
          if (scope.inputEnabled) {
            input.removeAttr('disabled');
          }
        }
      });
      attr.$observe('resetSelectionEnabled', function (reset) {
        scope.resetSelectionEnabled = reset;
        setDefaultValues(scope);
      });
      scope.$watchCollection('itemList', function () {
        itemsListService.setList(scope);
        if (!_.isEmpty(newItem)) {
          scope.selectItem(newItem);
          newItem = itemsListService.isListOfStrings(scope) ? '' : {};
        }
      });
      scope.$watch('activeIndex', function (activeIndex) {
        var item;
        if (activeIndex >= 0) {
          item = scope.filteredItemList[activeIndex];
          scope.scrollTo(item);
        }
      });
      scope.$on('rmCombobox:refresh', function () {
        render();
      });
      ngModelCtrl.$render = render;
      if (input.val() === scope.placeholder) {
        ngModelCtrl.$setValidity('required', true);
        ngModelCtrl.$validate();
      }
      if (scope.showTooltip) {
        dropdown.tooltip();
      }
      dropdownToggle.on('click', setDropdownStyles);
      dropdown.on('keydown', eventsService.onKeyDownHandler.bind(this, scope));
      dropdown.on('shown.bs.dropdown', function () {
        $timeout(function () {
          input.focus();
          input.select();
        }, 0);
      });

      /**
       * Needed to track if there was a click on the list,
       * if so the blur event needs to be ignored
       */
      ul.on('mousedown', function () {
        mouseDownOnOptionsHappened = true;
      });
      if (scope.inputEnabled) {
        input.on('input', eventsService.onInputHandler.bind(this, scope, ngModelCtrl, input, elem));
        input.on('click', eventsService.onInputClickHandler.bind(this, scope.typeAhead, input, showDropdown));
        input.on('keypress', function (event) {
          eventsService.onInputKeyPressHandler(input, ul, event);
          $timeout(function () {
            scope.$broadcast('vsRepeatTrigger');
          }, 0);
        });
        input.on('blur', function () {
          if (mouseDownOnOptionsHappened) {
            mouseDownOnOptionsHappened = false;
          } else {
            scope.$apply(function () {
              itemsListService.setEditableOption(scope, ngModelCtrl, input.val().toString());
              render();
            });
          }
        });
      } else {
        // remove <input> if the field is not needed
        input.remove();
      }
    }
  };
};
ComboboxDirective.$inject = ['$timeout', 'EventsService', 'ItemsListService', 'UserSecureService', '$document'];
module.exports = ComboboxDirective;